import React from 'react';
import PropTypes from 'prop-types';
import Coupon from '@components/Coupon';
import './CartCount.scss';

const CartCount = ({ itemsCount, total }) => (
  <div className="CartCountContainer">
    <div className="headingTitle">Order Cart</div>
    <div>
      <div>
        <div className="headingText">Total Items:</div>
        <div className="subHeadingText"> {itemsCount}</div>
      </div>
      <div>
        <div className="headingText">Total Cart Value:</div>
        <div className="subHeadingText"> {total || 'Price to be updated'}</div>
      </div>
    </div>
    <div className="coupon">
      <Coupon canApply position="left" />
    </div>
  </div>
);

CartCount.propTypes = {
  itemsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

CartCount.defaultProps = {
  itemsCount: 0,
  total: 0,
};

export default CartCount;
